import { AfterContentInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { RenderFormControlDirective } from '../../directives/render-form-control.directive';
import { FormControlGridDirective } from '../../directives/form-control-grid.directive';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'eg-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RenderFormControlDirective,
    FormControlGridDirective,
    MatFormFieldModule  
  ],
  templateUrl: './eg-form.component.html',
  styleUrl: './eg-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EgFormComponent implements OnInit,AfterContentInit {
  @Input() subform_id: any = []; // subform list
  @Input() stepIndex : any;
  @Input() dynFormGroup: FormGroup = this.formBuilder.group({});
  @Input() subForm: any = []; // subform list
  public formFields: any[] = [];
  @Input() formStyles: any;

  constructor(private readonly formBuilder: FormBuilder, private readonly cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    this.dynFormGroup = changes['dynFormGroup']?.currentValue;
  }

  ngOnInit() {
  }


  ngAfterContentInit(){
  }

  ngOnDestroy() {
  }
  // Call this method whenever you want to trigger change detection
  triggerChangeDetection() {
    this.cdr.markForCheck(); // or this.cdr.detectChanges();
  }
}
